import { render, staticRenderFns } from "./MatchOrderMatching.vue?vue&type=template&id=81bdb804&scoped=true"
import script from "./MatchOrderMatching.vue?vue&type=script&lang=js"
export * from "./MatchOrderMatching.vue?vue&type=script&lang=js"
import style0 from "./MatchOrderMatching.vue?vue&type=style&index=0&id=81bdb804&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bdb804",
  null
  
)

export default component.exports